import { useState } from "react";
import WirePage from "./WirePage";
import SpeakerPage from "./SpeakerPage";
import { AuroraBackground } from "./LandingComponents/aurora-background";
import { cn } from "../lib/utils";

// import your images as modules
import bgWire from "../assets/landing/bg-wire.jpg";
import bgSpeaker from "../assets/landing/bg-speaker.jpg";

const cards = [
  {
    title: "Steel Wire",
    slug: "wire",
    description: "",
    image: bgWire,
  },
  {
    title: "Speakers",
    slug: "speaker",
    description: "",
    image: bgSpeaker,
  },
];

export default function LandingPage() {
  const [currentPage, setCurrentPage] = useState("landing");

 if (currentPage === "wire") return <WirePage setCurrentPage={setCurrentPage} />;
  if (currentPage === "speaker") return <SpeakerPage setCurrentPage={setCurrentPage} />;

  return (
    <AuroraBackground className="relative w-full h-screen flex items-center justify-center overflow-hidden">
      <div className="max-w-screen-2xl mx-auto px-6 text-center z-10">
        {/* Heading */}
        <div className="w-full flex justify-center items-center overflow-hidden px-2 mb-8">
          <img src="./ksLogo-V2.png" className="w-10 md:mx-2 mr-2" alt="logo" />
          <p className="px-2 mx-2 my-4 border-l-2 border-gray-400">
            <img
              src="./textLogoWhite-V2.png"
              className="h-6 md:mx-2 mr-2"
              alt="logo"
            />
          </p>
        </div>

        <h2 className="text-3xl lg:text-4xl text-white mb-4 lg:mb-8">
          The Power Behind Our Innovation
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full justify-center items-center p-4 rounded-lg">
          {cards.map(({ title, slug, description, image }) => (
            <div
              key={slug}
              className="max-w-md w-full md:w-[320px] hover:scale-105 transition-transform duration-300"
            >
              <div
                onClick={() => setCurrentPage(slug)}
                className={cn(
                  "group w-full cursor-pointer overflow-hidden relative h-40 lg:h-96 rounded-md shadow-xl mx-auto flex flex-col justify-end",
                  "transition-all duration-500 bg-cover bg-center"
                )}
                style={{ backgroundImage: `url(${image})` }}
              >
                <div className="absolute inset-0 bg-black/50" />
                <div className="relative z-10 p-4">
                  <h1 className="font-bold text-2xl md:text-3xl text-gray-50">
                    {title}
                  </h1>
                  <p className="font-normal text-base text-gray-50 my-4">
                    {description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AuroraBackground>
  );
}
